$(document).ready(function () {

    /*
        MODULES
     */

    $('.mod-chronology .blocks .block-year').on('click', function () {
        var block = $(this).attr('href');
        var block_top = $('.blocks ' + block).offset().top;

        $('.mod-chronology .blocks .block-year.active').removeClass('active');

        $(this).addClass('active');

        $('html, body').animate({scrollTop: block_top - 150});

        return false;
    });

    $('#main .mod-points-forts .owl-carousel').owlCarousel({
        items: 1,
        loop: false,
        nav: false,
        dots: true,
        margin: 30,
        responsive:{
            480:{
                items:1
            },
            767:{
                items:2
            },
            991:{
                items:3
            }
        }
    });

    $('#main .mod-points-forts .block').on('click', function() {
        var dest = $(this).data('href');

        document.location.href = dest;

        return false;
    });

    $(window).scroll(function () {
        if ($('.mod-chronology').length > 0)
            check_scroll_position();
    });

    if ($('.mod-chronology').length > 0)
        check_scroll_position();
});

function check_scroll_position() {
    var actualScroll = $(window).scrollTop() + 150;

    if ($('.mod-chronology').offset().top <= actualScroll) {
        $('.mod-chronology .blocks #blocks-dates').removeClass('bottom');
        $('.mod-chronology .blocks #blocks-dates').addClass('fixed');
    } else {
        $('.mod-chronology .blocks #blocks-dates').removeClass('fixed');
    }

    if (actualScroll >= $('.mod-chronology').offset().top + $('.mod-chronology').height() - $('.mod-chronology .blocks #blocks-dates').height()) {
        $('.mod-chronology .blocks #blocks-dates').removeClass('fixed');
        $('.mod-chronology .blocks #blocks-dates').addClass('bottom');
    }


    $(".mod-chronology .blocks .block-content").each(function (i) {

        if ($(this).offset().top <= actualScroll+100) {
            $('.mod-chronology .blocks .block-year.active').removeClass('active');
            $('.mod-chronology .blocks .block-year[href="#'+ $(this).attr('id') +'"]').addClass('active');
        }
    })
}